import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  container: {
    ...dFlex('center', 'center'),
    flexDirection: 'row',
    width: '100%',
    gap: 8,
  },
}));

export default useStyles;
